import React from "react";
import { observer, inject } from "mobx-react";

export const Countdown = inject("store")(
  observer((props) => {
    const renderer = ({ hours, minutes, seconds, completed }) => {
      if (completed) {
        return <span>Süre doldu</span>;
      } else if (hours > 0) {
        return (
          <span>
            {hours}:{minutes}:{seconds}
          </span>
        );
      } else {
        return (
          <span>
            {minutes}:{seconds}
          </span>
        );
      }
    };
  })
);
